import { Vector3 } from 'three';

import { Component, PlatePair } from '@paragon/contract-library';
import { LineSegment2D } from '@paragon/geometry-library';
import { calculateMemberMidline, platePairToPolygonsWorldCoordinates } from '@paragon/three-shared';

export const findMembersWhichTouchPlatePair = (component: Component, platePair: PlatePair) => {
  const platePairPolygons = platePairToPolygonsWorldCoordinates(platePair);
  return component.members.filter((member) => {
    const midline = calculateMemberMidline(member, component);
    if (!midline) {
      console.log('Cannot find midline for member.');
      return false;
    }
    const midlineSegment = LineSegment2D.fromSegmentObject(midline);

    for (const platePairPolygon of platePairPolygons) {
      for (let i = 0; i < platePairPolygon.length; i += 1) {
        const nextPlatePolygonPoint = i === platePairPolygon.length - 1 ? platePairPolygon[0] : platePairPolygon[i + 1];
        const plateSegment = LineSegment2D.fromPointObjects(platePairPolygon[i], nextPlatePolygonPoint);
        if (midlineSegment.intersectWithSegment(plateSegment)) {
          return true;
        }
      }
    }

    const geometry = member.geometry.map((point) => new Vector3(point.x, point.y, 0));
    for (let i = 0; i < geometry.length; i += 1) {
      const nextMemberPolygonPoint = i === geometry.length - 1 ? geometry[0] : geometry[i + 1];
      const memberSegment = LineSegment2D.fromPointObjects(geometry[i], nextMemberPolygonPoint);
      for (const platePairPolygon of platePairPolygons) {
        for (let j = 0; j < platePairPolygon.length; j += 1) {
          const nextPlatePolygonPoint =
            j === platePairPolygon.length - 1 ? platePairPolygon[0] : platePairPolygon[j + 1];
          const plateSegment = LineSegment2D.fromPointObjects(platePairPolygon[j], nextPlatePolygonPoint);
          if (memberSegment.intersectWithSegment(plateSegment)) {
            return true;
          }
        }
      }
    }
    return false;
  });
};
